import { render, staticRenderFns } from "./Gigs.vue?vue&type=template&id=679ddca8&scoped=true&lang=pug"
import script from "./Gigs.vue?vue&type=script&lang=js"
export * from "./Gigs.vue?vue&type=script&lang=js"
import style0 from "./Gigs.vue?vue&type=style&index=0&id=679ddca8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ddca8",
  null
  
)

export default component.exports